import React from 'react';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { ProductFilterComponents } from './product-filter-components';
import { IProductFilters } from './types';
import { FiltersWrapper } from './styles';

export const ProductFilters: React.FC<IProductFilters> = props => {
  const { category, product } = props;

  const renderProductFilterComponents = (isMobile: boolean) => {
    return (
      <FiltersWrapper>
        <ProductFilterComponents
          isMobile={isMobile}
          category={category}
          product={product}
        />
      </FiltersWrapper>
    );
  };

  return (
    <>
      <MediumUp>{renderProductFilterComponents(false)}</MediumUp>
      <MobileOnly>{renderProductFilterComponents(true)}</MobileOnly>
    </>
  );
};
